// extracted by mini-css-extract-plugin
export default {"box":"Modal_box__GdP9y"};